







import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { PRODUCTS_API } from '~/assets/config/api-path'
import { ISiteScriptItem } from '~/assets/interfaces/site'
import ComponentProductScriptsInner from '~/components/products/product-scripts-inner.vue'

@Component({
  components: {
    ComponentProductScriptsInner,
  },
})
export default class ComponentProductScripts extends Vue {
  @Prop({ type: [Number, String], default: '-1' }) readonly productId!:
    | number
    | string

  private isShowBase = false
  private async created() {
    const response = await this.$axios.$get(
      PRODUCTS_API + '/' + this.productId + '/scripts'
    )
    response.items.forEach((item: ISiteScriptItem) => {
      if (!this.base[item.type]) {
        this.base[item.type] = []
      }
      this.base[item.type].push({ ...item.attr })
    })
    this.isShowBase = true
  }

  private base: any = {}
}
